import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../zustand/useAuthStore";
import { UserRole } from "../interfaces/UserRole";

interface RoleProtectedRouteProps {
  allowedRoles: UserRole[];
}

export default function RoleProtectedRoute({ allowedRoles }: RoleProtectedRouteProps) {
  const { isAuthenticated, user } = useAuthStore();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user || !allowedRoles.includes(user.role)) {
    // Si el usuario no tiene permisos, redirigir a una ruta permitida
    // Digitador solo puede ver paquetes y envíos
    if (user?.role === UserRole.Digitador) {
      return <Navigate to="/" replace />;
    }
    // Para otros casos, redirigir al home
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
